$(document).ready(function() {
    var today = new Date(Date.now());
    var firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
    var lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);
    if ($('#startDate').length) {
        $('#startDate').kendoDatePicker({
            value: firstDay,
            format: 'yyyy-MM-dd',
            change: function(e) {
                $('#customer-chart')
                    .data('kendoChart')
                    .dataSource.read();
            }
        });

        $('#endDate').kendoDatePicker({
            value: lastDay,
            format: 'yyyy-MM-dd',
            change: function(e) {
                $('#customer-chart')
                    .data('kendoChart')
                    .dataSource.read();
            }
        });

        $('#customer-chart').kendoChart({
            dataSource: {
                transport: {
                    read: {
                        url: '/' + URLSEGMENT + '/customersfeedchart',
                        dataType: 'json',
                        data: function() {
                            return {
                                startDate: getStartDate(),
                                endDate: getEndDate()
                            };
                        },
                        type: 'POST'
                    }
                },
                change: function(e) {
                    updateChartInformation(this.data());
                },
                group: {
                    field: 'name'
                },
                sort: {
                    field: 'Day',
                    dir: 'asc'
                }
            },
            title: {
                text: 'Daily referrals'
            },
            chartArea: {
                height: 380
            },
            legend: {
                position: 'top'
            },
            series: [
                {
                    type: 'line',
                    field: 'Count'
                }
            ],
            categoryAxis: {
                field: 'Day',
                labels: {
                    rotation: 0,
                    template: "#= kendo.toString( new Date(value), 'd/MM') #"
                }
            },
            valueAxis: {
                field: 'Count',
                majorUnit: 1,
                title: {
                    text: 'Amount Of Referrals',
                    rotation: -90
                }
            },
            tooltip: {
                visible: true,

                template:
                    "#= dataItem.name #'s Customers : #= dataItem.Count # (#= kendo.format('{0:d}', dataItem.Day) #)"
            }
        });
    }
    if (typeof window.customersGrid !== 'undefined') {
        $('#customers-grid').kendoGrid({
            selectable: false, //'multiple,row',
            sortable: true,
            filterable: true,
            pageable: true,
            columns: [
                {
                    field: 'FirstName',
                    title: 'First Name',
                    width: '150px'
                },
                {
                    field: 'Surname',
                    title: 'Surname',
                    width: '150px'
                },
                {
                    field: 'HasBeenApproved',
                    title: 'Has been Approved?',
                    width: '125px'
                },
                {
                    field: 'Email',
                    title: 'Email',
                    width: '200px'
                },
                {
                    filterable: false,
                    title: '',
                    width: '125px',
                    template:
                        ' <a href="/affiliate/editcustomer/${ID}" id="edit-customer-${ ID }" data-record-id="${ ID }" class="btn small primary edit-btn">Edit</a>'
                }
            ],
            dataSource: window.customersGrid,
            pageable: {
                pageSize: 10
            }
        });
    }
});

function getStartDate() {
    return (
        $('#startDate')
            .data('kendoDatePicker')
            .value()
            .getTime() / 1000
    );
}
function getEndDate() {
    return (
        $('#endDate')
            .data('kendoDatePicker')
            .value()
            .getTime() / 1000
    );
}

function updateChartInformation(data) {
    var isData = typeof data['0'] !== 'undefined';
    var total = 0;
    var dayStepAmt = 1;

    if (isData) {
        dayStepAmt = data[0].dayStepAmt;
        total = data[0].Total;
    }

    var start = $('#startDate')
        .data('kendoDatePicker')
        .value();
    var end = $('#endDate')
        .data('kendoDatePicker')
        .value();
    var firstDay = new Date(start.getFullYear(), start.getMonth(), 1);
    var lastDay = new Date(end.getFullYear(), end.getMonth() + 1, 0);
    $('#customer-chart').data('kendoChart').options.title.text =
        "<tspan x='300' dy='0' text-anchor='middle'>Daily customer intake for each affiliate</tspan> " +
        "<tspan x='700' dy='0'text-anchor='middle'>(" +
        firstDay.toDateString() +
        ' - ' +
        lastDay.toDateString() +
        ')</tspan>' +
        "<tspan x='500' dy='1em'text-anchor='middle'>My Customer Total: " +
        total +
        '</tspan>';
    $('#customer-chart').data('kendoChart').options.categoryAxis.labels.step = dayStepAmt;
}
